import { Component, OnInit } from '@angular/core';
import { JackpotService } from '@app/core/jackpot.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-jackpot-fairness-modal',
  templateUrl: './jackpot-fairness-modal.template.html',
  styleUrls: ['./jackpot-fairness-modal.template.scss'],
  animations: [],
})
export class JackpotFairnessModalComponent implements OnInit {
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, public jackpotService: JackpotService) {}

  public ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.form = this.formBuilder.group({
        jackpotId: params.jid,
        clientSeed: params.cs,
        serverSeed: params.ss,
        keyCode: '',
        participantName: '',
      });
    });
    this.checkFairness();
  }

  public checkFairness() {
    this.jackpotService
      .getJackpotFairness(this.form.value)
      .then(data => {
        this.form.get('keyCode').patchValue(data.winningKey);
        this.form.get('participantName').patchValue(data.winningUser);
      })
      .catch(e => {
        this.form.get('keyCode').patchValue(null);
        this.form.get('participantName').patchValue(null);
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/jackpot-fairness/jackpot-fairness-modal.component.ts